var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-table-container" },
    [
      _c(
        "div",
        { staticClass: "table-item" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.data.tppUpdateHistories,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.tableIndex,
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.systemPk"),
                  width: "80",
                  align: "left",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tppUpdateStatus",
                  label: _vm.$t(
                    "retailStoresInfo.form.ttpSignAesc.signingStatus"
                  ),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtmTypeOld",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.RTMOldType"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rtmTypeNew",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.RTMNewType"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerTypeOld",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.stoOldType"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerTypeNew",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.stoNewType"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "gyTppVolumeOld",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.GYOldSign"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "gyTppVolumeNew",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.GYNewSign"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cpTppVolumeOld",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.CPOldSign"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cpTppVolumeNew",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.CPNewSign"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "effectiveStartMonth",
                  label: _vm.$t(
                    "retailStoresInfo.form.ttpSignAesc.effectiveDate"
                  ),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.createTime"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "lastUpdateTime",
                  label: _vm.$t("retailStoresInfo.form.ttpSignAesc.updateTime"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.data.tppInfoVos, function (item, key) {
        return _c(
          "div",
          { key: key, staticClass: "table-item" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: item.tppInfos,
                  "highlight-current-row": "",
                  "tooltip-effect": "dark",
                },
              },
              [
                _c(
                  "el-table-column",
                  { attrs: { label: String(item.year), align: "center" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        index: _vm.tableIndex,
                        label: _vm.$t(
                          "retailStoresInfo.form.ttpSignAesc.systemPk"
                        ),
                        width: "80",
                        align: "left",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "brandType",
                        label: _vm.$t("retailStoresInfo.form.year.brand"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "january",
                        label: _vm.$t("retailStoresInfo.form.year.january"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "february",
                        label: _vm.$t("retailStoresInfo.form.year.february"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "march",
                        label: _vm.$t("retailStoresInfo.form.year.march"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "april",
                        label: _vm.$t("retailStoresInfo.form.year.april"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "may",
                        label: _vm.$t("retailStoresInfo.form.year.may"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "june",
                        label: _vm.$t("retailStoresInfo.form.year.june"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "july",
                        label: _vm.$t("retailStoresInfo.form.year.july"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "august",
                        label: _vm.$t("retailStoresInfo.form.year.august"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "september",
                        label: _vm.$t("retailStoresInfo.form.year.september"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "october",
                        label: _vm.$t("retailStoresInfo.form.year.october"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "november",
                        label: _vm.$t("retailStoresInfo.form.year.november"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "december",
                        label: _vm.$t("retailStoresInfo.form.year.december"),
                        width: "100",
                        align: "left",
                        "show-overflow-tooltip": "",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }